import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";

import {
  Doughnut,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { formatDateNew, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { getStoreOrderSource } from "../../../services/DashboardAPI/DashboardApi";
import AnalyticsSchedularModal from "../../AnalyticsSchedularModal";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const TopPerformerNew = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const userRole = userProfileRole;
  const brandId = brandProfileData.id;

  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [analyticsSchedularModalVisible, setAnalyticsSchedularModalVisible] =
    useState(false);
  const [schedularDate, setSchedularDate] = useState({});
  const [revenueData, setRevenueData] = useState([]);
  const [orderData, setOrderData] = useState([]);

  const [revenueDataNew, setRevenueDataNew] = useState({});
  const [orderDataNew, setOrderDataNew] = useState({});

  const [totalRevenueData, setTotalRevenueData] = useState(0);
  const [totalOrderData, setTotalOrderData] = useState(0);

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));  

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
    setInitialDateValue(newSchedular.startDate)
    setEndDate(newSchedular.endDate)
  };

  const handleCalendarModal = () => {
    setAnalyticsSchedularModalVisible(true);
  };
  const [loading, setLoading] = useState(false);

  const fetchStoreOrderDashboard = (data) => {
    setLoading(true);
    getStoreOrderSource(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // const arrayResult = [
          //   {
          //     id: 0,
          //     name: "BOOKING_RIDER",
          //     orderCount: Res["BOOKING_RIDER"].orderCount,
          //     revenue: Res["BOOKING_RIDER"].revenue,
          //   },
          //   {
          //     id: 1,
          //     name: "BOOKING_STORE",
          //     orderCount: Res["BOOKING_STORE"].orderCount,
          //     revenue: Res["BOOKING_STORE"].revenue,
          //   },
          // ];
          const resultRevenueData = Res.map((item, index) => ({
            ...item,
            value: item.totalSale,
            gradientCenterColor:
              chartsGradientRevenue[index % chartsGradientRevenue.length], // Assuming getRandomColor() generates a random color
            color: chartsColorRevenue[index % chartsColorRevenue.length],
          }));
          const resultOrderData = Res.map((item, index) => ({
            ...item,
            value: item.totalCount,
            gradientCenterColor:
              chartsGradientOrder[index % chartsGradientOrder.length], // Assuming getRandomColor() generates a random color
            color: chartsColorOrder[index % chartsColorOrder.length],
          }));

          const resultRevenueDataNew = {
            labels: resultRevenueData?.map((item) =>
              item.orderSource.replace(/BY_/g, " ")
            ),
            datasets: [
              {
                label: ["Revenue"],
                data: resultRevenueData?.map((item) => item.value),
                backgroundColor: resultRevenueData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };

          const resultOrderDataNew = {
            labels: resultOrderData?.map((item) =>
              item.orderSource.replace(/BY_/g, " ")
            ),
            datasets: [
              {
                label: ["Orders"],
                data: resultOrderData?.map((item) => item.value),
                backgroundColor: resultOrderData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };

          setRevenueData(resultRevenueData);
          setOrderData(resultOrderData);
          setRevenueDataNew(resultRevenueDataNew);
          setOrderDataNew(resultOrderDataNew);

          const totalRevenue = Res.reduce(
            (acc, item) => acc + item.totalSale,
            0
          );
          const totalOrder = Res.reduce(
            (acc, item) => acc + item.totalCount,
            0
          );
          setTotalRevenueData(totalRevenue);
          setTotalOrderData(totalOrder);

          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const chartsGradientRevenue = ["#C58C00", "#F4C145"];

  const chartsColorRevenue = ["#C58C00", "#F4C145"];

  const chartsGradientOrder = ["#8F4700", "#EC7A08"];

  const chartsColorOrder = ["#8F4700", "#EC7A08"];

  const initialDate = new Date(startDate);
  initialDate.setDate(initialDate.getDate() - 30);

  const [initialDateValue, setInitialDateValue] = useState(initialDate)
  

  const fetchBrandStoreInfo = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeIds = Res.map((item) => item.id);
          const data = {
            storeIds: storeIds,
            startDate: schedularDate?.startDate
                ? localeDateStartDate(new Date(schedularDate.startDate))
                : localeDateStartDate(new Date(initialDate)),
            endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate.endDate)) : localeDateEndDate(new Date(endDate)),
            pendingStartDate:
              brandProfileData.createdDate !== null
                ? brandProfileData.createdDate
                : initialDate,
          };
          fetchStoreOrderDashboard(data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchFranchiseStore = async () => {
      const franchiseStore = await getLocalFranchiseStore();
      if (franchiseStore.franchiseStore !== null) {
        const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
        const storeIds = Res.map((item) => item.id);
       const data = {
         storeIds: storeIds,
         startDate: schedularDate?.startDate
           ? localeDateStartDate(new Date(schedularDate.startDate))
           : localeDateStartDate(new Date(initialDate)),
         endDate: schedularDate?.endDate ? localeDateStartDate(new Date(schedularDate.endDate)) : localeDateStartDate(new Date(endDate)),
         pendingStartDate:
           brandProfileData.createdDate !== null
             ? brandProfileData.createdDate
             : initialDate,
       };
       fetchStoreOrderDashboard(data);
      }  
    };

  useEffect(() => {
    if (userRole === "BY_FRANCHISE_ADMIN") {
      fetchFranchiseStore();
    } else {
      fetchBrandStoreInfo();
    }
  }, [schedularDate]);

  const Data = {
    labels: ["Rent", "Food", "Bills"],
    datasets: [
      {
        label: "Doughnut",
        data: [500, 200, 300],
        backgroundColor: ["purple", "orange", "green"],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "bottom" } },
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/AnalyticsList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Top Performer
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">ORDERS BY STORES & RIDERS</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Orders Data...</p>
            </div>
          ) : orderData.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <h4>
                  Period : {formatDateNew(initialDateValue.toString())} -{" "}
                  {formatDateNew(endDate.toString())}
                </h4>
              </div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 400 }}>
                  <Doughnut data={orderDataNew} options={chartOptions} />
                </div>
              </div>
              <div className="mx-4 my-3 flex justify-content-center">
                <h4>Total Orders : {totalOrderData}</h4>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Orders Found</p>
            </div>
          )}
        </div>

        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">REVENUE BY STORES & RIDERS</p>
              </div>
            </div>
          </div>
        
        {loading ? (
          <div className="flex flex-1 flex-column justify-content-center align-items-center">
            <ProgressSpinner />
            <p className="text-3xl font-bold">Loading Revenue Data...</p>
          </div>
        ) : revenueData.length > 0 ? (
          <div>
            <div className="mx-4 my-3 flex justify-content-center">
              <h4>
                Period : {formatDateNew(initialDateValue.toString())} -{" "}
                {formatDateNew(endDate.toString())}
              </h4>
            </div>
            <div className="mx-4 my-3 flex justify-content-center">
              <div className="flex " style={{ height: 400 }}>
                <Doughnut data={revenueDataNew} options={chartOptions} />
              </div>
            </div>
            <div className="mx-4 my-3 flex justify-content-center">
                  <h4>Total Revenue : {storeLocalData?.currencySymbol} {totalRevenueData}</h4>
            </div>
          </div>
        ) : (
          <div className="flex flex-1 justify-content-center align-items-center">
            <p className="text-3xl font-bold">No Revenue Found</p>
          </div>
        )}
        </div>
      </div>
      <AnalyticsSchedularModal
        analyticsSchedularModalVisible={analyticsSchedularModalVisible}
        setAnalyticsSchedularModalVisible={setAnalyticsSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default TopPerformerNew;
